export const SWITCH_REGION_SUCCESS = 'SWITCH_REGION_SUCCESS';